{
  "title": "Facturation",
  "notVisibleTitle": "La facturation ne vous est pas visible",
  "notVisibleBody": "Les détails d’abonnement sont visibles pour les administrateurs de locataire et au‑dessus.",
  "loadError": "Impossible de charger la facturation",
  "notConnectedTitle": "La facturation n’est pas connectée",
  "notConnectedBody": "Ce déploiement n’a pas d’identifiants Stripe. Définissez Stripe:SecretKey et au moins un Price id sur l’API pour activer les abonnements.",
  "checkoutCompleteTitle": "Paiement terminé",
  "checkoutCompleteBody": "En attente de la confirmation Stripe de l’abonnement…",
  "checkoutCompleteToast": "Paiement terminé. Stripe confirme l’abonnement.",
  "checkoutCancelledToast": "Le paiement a été annulé. Aucun montant n’a été débité.",
  "noSubscriptionTitle": "Pas d’abonnement",
  "noSubscriptionBody": "Ce locataire n’est pas encore facturé. Un abonnement facture un siège par boîte que la plateforme estampille.",
  "noSubscriptionConfirming": "Stripe confirme l’abonnement. Cette page se met à jour dès que c’est fait.",
  "startSubscription": "Démarrer un abonnement",
  "setupBilling": "Configurer la facturation",
  "subscription": "Abonnement",
  "plan": "Offre",
  "seats": "Sièges",
  "billedSeats": "Sièges facturés",
  "liveSeats": "Sièges en direct",
  "seatsValue": "facturés {{billed}} / actuels {{current}}",
  "outOfSync": "désynchronisés",
  "syncSeats": "Synchroniser les sièges",
  "seatsSynced": "Sièges synchronisés : facturation {{count}}.",
  "seatSyncFailed": "Échec de la synchronisation des sièges.",
  "openPortal": "Ouvrir le portail client",
  "manageInStripe": "Gérer la facturation dans Stripe",
  "portalOpenFailed": "Impossible d’ouvrir le portail de facturation.",
  "cancelAtPeriodEnd": "Résilier en fin de période",
  "resume": "Reprendre",
  "resumeSubscription": "Reprendre l’abonnement",
  "collectionCard": "Carte — débit automatique",
  "collectionInvoice": "Facture — envoyée avec délais de paiement",
  "collectionInvoiceNet": "Facture — envoyée avec délais de paiement (net {{days}} jours)",
  "statusNone": "Pas d’abonnement",
  "statusIncomplete": "Incomplet",
  "statusExpired": "Expiré",
  "statusTrialing": "Essai",
  "statusActive": "Actif",
  "statusPastDue": "En retard",
  "statusCanceled": "Résilié",
  "statusUnpaid": "Impayé",
  "statusPaused": "En pause",
  "setupTitle": "Configurer la facturation",
  "setupIntro": "Les forfaits suivent la grille Starter / Standard / Pro d’Exclaimer. Un siège par boîte que ce locataire fait estampiller — {{seats}} aujourd’hui{{minimum}} ; le décompte est réconcilié chaque nuit et les changements sont facturés sur la facture suivante.",
  "setupMinimumSuffix": ", facturé au minimum de {{minimum}} sièges",
  "periodMonthly": "Mensuel",
  "periodAnnual": "Annuel",
  "billedAnnually": "Facturation annuelle",
  "billedAnnuallySave": "Facturation annuelle (économisez {{percent}} %)",
  "billedMonthly": "Facturation mensuelle",
  "savePercent": "Économisez {{percent}} %",
  "planSeatRate": "{{name}} ({{rate}}/siège/mois)",
  "planStarter": "Starter",
  "planStandard": "Standard",
  "planPro": "Pro",
  "enterpriseAvailable": " Enterprise (devis sur mesure) disponible via les ventes.",
  "licensedBlocks": "Licencié par blocs à partir de {{minimum}} sièges — un locataire plus petit est facturé pour {{minimum}}. ",
  "noTrialReturning": "Ce locataire s’est déjà abonné, donc aucun essai ne s’applique.",
  "trialDays": "Les {{days}} premiers jours sont gratuits ; la première facture est émise à la fin de l’essai.",
  "payByCard": "Payer par carte",
  "invoiceCustomer": "Facturer le client",
  "methodCard": "Carte",
  "methodInvoice": "Facture",
  "methodCardHint": "Ouvre Stripe Checkout pour capturer une carte. Stripe la débite chaque période et le client la gère.",
  "methodInvoiceHint": "Stripe envoie une facture chaque période avec délais de paiement. Aucune carte n’est capturée.",
  "billingEmail": "E-mail de facturation",
  "billingEmailHint": "Où Stripe envoie factures et reçus.",
  "billingEmailPlaceholder": "comptes@client.com.au",
  "invoiceDueDays": "Échéance de facture (jours)",
  "setupFailed": "Impossible de configurer la facturation",
  "continueToStripe": "Continuer vers Stripe",
  "createSubscription": "Créer l’abonnement",
  "subscriptionCreated": "Abonnement créé. Stripe enverra les factures à {{email}}.",
  "cancelTitle": "Résilier en fin de période",
  "cancelBody": "L’abonnement reste actif jusqu’à la fin de la période en cours, puis ne se renouvellera pas.",
  "cancelBodyDetailed": "La facturation s’arrête à la fin de la période payée{{onDate}}. Les signatures restent estampillées jusqu’alors, et rien n’est remboursé ni débité aujourd’hui.",
  "cancelOnDate": " le {{date}}",
  "confirmCancel": "Confirmer la résiliation",
  "resumeBody": "L’abonnement se renouvellera à nouveau normalement.",
  "updateFailed": "Impossible de mettre à jour l’abonnement",
  "resumedToast": "Abonnement repris.",
  "cancelScheduledToast": "L’abonnement prendra fin à la fin de la période.",
  "paymentOverdueTitle": "Paiement en retard",
  "paymentOverdueBody": "Stripe n’a pas pu encaisser la dernière facture. Les signatures continuent d’être estampillées — rien ne s’arrête automatiquement — mais le compte nécessite une attention.",
  "scheduledCancelTitle": "Résiliation planifiée",
  "scheduledCancelBody": "Cet abonnement se termine le {{date}} et ne se renouvellera pas.",
  "scheduledCancelFallbackDate": "la fin de la période en cours",
  "billingLabel": "Facturation",
  "invoicesGoTo": "Les factures vont à",
  "notSet": "Non défini",
  "price": "Prix",
  "ends": "Se termine",
  "renews": "Se renouvelle",
  "seatsLastSynced": "Dernière sync des sièges",
  "manage": "Gérer",
  "manageHint": "Cartes, factures et reçus vivent dans Stripe. Les sièges sont réconciliés ici chaque nuit, et un changement prend effet sur la facture suivante plutôt qu’au milieu de celle-ci.",
  "mspOnlyHint": "Modifier ou résilier l’abonnement est réservé au personnel OnBrand Mail."
}
